var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"textStat white--text",attrs:{"x-large":"","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v("Rapportage")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }